import { createAction } from '@reduxjs/toolkit';
import { GET_DICTIONARIES_NATIONALITIES } from '../actionConstants';

export const getAllNationalitiesAction = createAction(
  GET_DICTIONARIES_NATIONALITIES
);
